import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProduct } from '../../api/products';
import { mediaUrl } from '../../api/client';


export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setProduct(null);
    setError(null);
    fetchProduct(id)
      .then(({ product: data }) => {
        if (!cancelled) setProduct(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to load product.');
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    if (activeImage === null) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setActiveImage(null);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [activeImage]);

  useEffect( () => {
    const script = document.createElement('script')
    if (product) {
      script.innerHTML = product.buy_button_script
      document.head.appendChild(script)

     }
    return () => {

    }
  })

  if (error) {
    return (
      <div className="product-page">
        <p className="product-error">{error}</p>
      </div>
    );
  }

  if (!product) {
    return <div className="product-page" />;
  }

  return (
    <div className="product-page">
      <section className="product-hero">
        {product.portrait_url && (
          <img
            className="product-hero-portrait"
            src={mediaUrl(product.portrait_url)}
            alt={product.title}
          />
        )}
        <div className="product-hero-info">
          <h1 className="product-hero-title">{product.title}</h1>
          {product.description && (
            <p className="product-hero-desc">{product.description}</p>
          )}
          {product.buy_button && (
              <div>

                <div dangerouslySetInnerHTML={{ __html: product.buy_button }} />
              </div>
          )}
        </div>
      </section>

      {product.images && product.images.length > 0 && (
        <section className="product-gallery">
          {product.images.map((image, index) => (
            <button
              key={image.id}
              type="button"
              className="product-gallery-item"
              onClick={() => setActiveImage(index)}
            >
              <img
                className="product-gallery-img"
                src={mediaUrl(image.image_url)}
                alt={`${product.title} ${index + 1}`}
              />
            </button>
          ))}
        </section>
      )}

      {activeImage !== null && product.images[activeImage] && (
        <div className="image-modal-overlay" onClick={() => setActiveImage(null)}>
          <button
            type="button"
            className="image-modal-close"
            onClick={() => setActiveImage(null)}
            aria-label="Close"
          >
            &times;
          </button>
          <img
            className="image-modal-img"
            src={mediaUrl(product.images[activeImage].image_url)}
            alt={`${product.title} ${activeImage + 1}`}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}